// ═══════════════════════════════════════════════════════════
// App init:
//   1) Force light theme (dark mode disabled at user request)
//   2) Lock zoom on iOS — block pinch + double-tap gestures
//      (viewport meta covers most cases, JS catches the iOS edges)
// ═══════════════════════════════════════════════════════════

export function initAutoTheme() {
  if (typeof window === "undefined") return;
  const html = document.documentElement;
  html.classList.remove("dark");
  html.style.colorScheme = "light";
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", "#FFFFFF");

  // ── Lock zoom (iOS Safari) ────────────────────────────────
  // 1) Block multi-touch gesture zoom
  ["gesturestart", "gesturechange", "gestureend"].forEach((evt) => {
    document.addEventListener(evt, (e) => e.preventDefault(), { passive: false });
  });
  // 2) Block double-tap zoom (300 ms window between taps)
  let lastTap = 0;
  document.addEventListener("touchend", (e) => {
    const now = Date.now();
    if (now - lastTap < 300 && e.touches.length === 0) e.preventDefault();
    lastTap = now;
  }, { passive: false });
}
